enum ErrorMessage {
  ConnectWallet = "Please connect your wallet",
  ChooseFile = "Please choose a file",
  InputsValid = "Please make sure all inputs are valid",
  InvalidAddress = "Invalid address",
}

export default ErrorMessage;
